<template>
  <div>
    <label class="form__label primary--text" :for="idElement" v-if="labelText">
      {{ labelText }}
      <v-tooltip
        bottom
        v-if="iconInformation"
        content-class="tooltip-label-form"
      >
        <template v-slot:activator="{ on }">
          <v-icon color="secondary" size="10" v-on="on">
            fa-info-circle
          </v-icon>
        </template>
        <v-row>
          <v-col cols="12" class="px-4 py-3">
            <p class="white--text tooltip-label-text mb-0">
              {{ textInformation }}
            </p>
          </v-col>
        </v-row>
      </v-tooltip>
    </label>
    <v-text-field
      v-on="$listeners"
      v-bind="defaultConfigs"
      :id="idElement"
      :data-cy="cypressId"
      @input="onInput"
    />
  </div>
</template>
<script>
const defaultProp = {
  outlined: true,
  class: "mt-2",
  dense: true,
  "background-color": "white"
};
export default {
  model: {
    event: "update"
  },
  computed: {
    defaultConfigs() {
      return {
        ...this.$attrs,
        ...this.$props,
        ...defaultProp
      };
    }
  },
  methods: {
    onInput(value) {
      const text = this.upperCase && value != null ? value.toUpperCase() : value;
      this.$emit("update", text);
    }
  },
  props: {
    idElement: {
      type: String
    },
    labelText: {
      type: String
    },
    iconInformation: {
      type: Boolean,
      default: false
    },
    textInformation: {
      type: String
    },
    cypressId: {
      type: String,
      default: null
    },
    upperCase: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style lang="sass">
.v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot
  min-height: 40px !important
.theme--light.v-input--is-disabled
  fieldset
    background-color: #F0F0F7
    color: #676778
.tooltip-label-form
  border-radius: 2px
  background-color: #676778
  box-shadow: 0 7px 10px 0 rgba(44,48,64,0.21)
  max-width: 172px
.tooltip-label-text
  font-size: 12
  font-weight: 500
  letter-spacing: 0
  line-height: 16px
  text-align: center
</style>
